import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../configs/Firebase';

export const login = async ({ email, password }) => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);

    return {
      success: true,
      message: 'User Login Successfull',
      data: {
        user: result.user,
        uid: result.user.uid,
        name: result.user.name,
        email: result.user.email,
      },
    };
  } catch (err) {
    switch (err.code) {
      case 'auth/wrong-password':
        return {
          success: false,
          message: 'You Entered Wrong Password',
        };
      case 'auth/too-many-requests':
        return {
          success: false,
          message: 'Please try again later',
        };
      case 'auth/user-not-found':
        return {
          success: false,
          message: 'User Not Found',
        };
      default:
        return {
          success: false,
          message: 'User Login failed',
        };
    }
  }
};
export const logOut = async () => {
  await auth.signOut();
};
